import styled from 'styled-components';

export const BlockWrapper = styled.div`
	padding: 40px 40px 0;

	@media ${props => props.theme.device.tablet} {
		padding: 40px 20px 0;
	}

	@media ${props => props.theme.device.smTablet} {
		padding: 32px 20px 0;
	}

	@media ${props => props.theme.device.mobile} {
		padding: 32px 12px 0;
	}

	& table {
		width: 100%;
		table-layout: fixed;
		border-style: hidden;
		border-collapse: collapse;
		border-spacing: 0;
		border: 1px solid #c5c5c5;
		border-width: 0.5px;
	}
	& td {
		background-color: #fff;
    border: 1px solid #c5c5c5;
    border-width: 0.5px;
    overflow: visible;
    cursor: text;
		padding: 10px 15px;
	}
`;
